// @ts-strict-ignore
import { atom } from 'jotai'
import { BeneficiaryTransferDestination, BeneficiaryType } from 'types/beneficiaries'
import { WalletTypes } from 'types/types'
import { DocumentUpload } from 'types/verification'
import {
  FiatPayout,
  MassPayoutButtonGroup,
  MassPayoutButtonGroupType,
  MassPayoutCryptoBatch,
  MassPayoutPostAuthRequest,
  MassPayoutSteps,
  MassPayoutStepsType,
  ModalVariant,
  ModalVariantType,
  PreProcessedPayouts,
} from '../types'

interface ModalAtomProps {
  variant?: ModalVariantType
  isOpen: boolean
}

export const merchantAtom = atom('')
merchantAtom.debugLabel = 'merchant'

export const walletAtom = atom<string>('')
walletAtom.debugLabel = 'wallet'

export const fileAtom = atom<DocumentUpload | null>(null as DocumentUpload)
fileAtom.debugLabel = 'file'

export const uploadErrorAtom = atom<React.ReactNode>('')
uploadErrorAtom.debugLabel = 'upload-error'

export const fileNameAtom = atom('')
fileNameAtom.debugLabel = 'file-name'

export const massPayoutStepAtom = atom<MassPayoutStepsType>(MassPayoutSteps.FORM)
massPayoutStepAtom.debugLabel = 'mass-payout-step'

export const walletTypeAtom = atom(WalletTypes.CRYPTO)
walletTypeAtom.debugLabel = 'wallet-type'

export const modalAtom = atom<ModalAtomProps>({
  variant: ModalVariant.PROCESSED,
  isOpen: false,
})
modalAtom.debugLabel = 'modal'

export const fiatBatchReferenceAtom = atom<string>('')
fiatBatchReferenceAtom.debugLabel = 'fiat-batch-reference'

export const fiatBatchInformationAtom = atom<FiatPayout>(null as FiatPayout)
fiatBatchInformationAtom.debugLabel = 'fiat-batch-information'

export const fiatBatchListAtom = atom<FiatPayout[]>(null as FiatPayout[])
fiatBatchListAtom.debugLabel = 'fiat-batch-list'

export const isEditPayoutModalVisibleAtom = atom<boolean>(false)
isEditPayoutModalVisibleAtom.debugLabel = 'is-edit-payout-modal-visible'

export const authRequestAtom = atom<MassPayoutPostAuthRequest>(null as MassPayoutPostAuthRequest)
authRequestAtom.debugLabel = 'auth-request'

export const isConfirmBatchModalVisibleAtom = atom<boolean>(false)
isConfirmBatchModalVisibleAtom.debugLabel = 'is-confirm-batch-modal-visible'

export const preProcessedRecordToUpdateAtom = atom<PreProcessedPayouts>(null as PreProcessedPayouts)
preProcessedRecordToUpdateAtom.debugLabel = 'pre-processed-record-to-update'

export const preProcessedRecordToDeleteAtom = atom<PreProcessedPayouts>(null as PreProcessedPayouts)
preProcessedRecordToDeleteAtom.debugLabel = 'pre-processed-record-to-delete'

export const totalPaymentsAtom = atom<number>(0)
totalPaymentsAtom.debugLabel = 'total-payments'

export const totalNumberOfPayoutsAtom = atom<number>(0)
totalNumberOfPayoutsAtom.debugLabel = 'total-number-of-payouts'

export const totalNumberOfPayoutErrorsAtom = atom<number>(0)
totalNumberOfPayoutErrorsAtom.debugLabel = 'total-number-of-payout-errors'

export const beneficiaryTypeAtom = atom<BeneficiaryType>(null as BeneficiaryType)
beneficiaryTypeAtom.debugLabel = 'beneficiary-type'

export const transferDestinationAtom = atom<BeneficiaryTransferDestination>(
  null as BeneficiaryTransferDestination
)
transferDestinationAtom.debugLabel = 'transfer-destination'

export const MassPayoutButtonGroupAtom = atom<MassPayoutButtonGroupType>(
  MassPayoutButtonGroup.BATCH_INITIAL
)
MassPayoutButtonGroupAtom.debugLabel = 'mass-payout-button-group'

export const cryptoBatchListAtom = atom<MassPayoutCryptoBatch[]>([])
cryptoBatchListAtom.debugLabel = 'crypto-batch-list'
